import * as Yup from "yup";

export const kursusDeltagereMoveFormConfig = (
  kursusId: string,
  kursusPersonId: string,
): FormConfig<MoveKursusPersonDTO> => {
  const get = `kursus/${kursusId}/deltagere/${kursusPersonId}`;
  const moveQuery = `kursus/${kursusId}/wizards/flytkursusperson/${kursusPersonId}`;
  return {
    title: "deltager",
    get,
    lockedValues: [
      {
        id: "kursusId",
        value: kursusId,
      },
      {
        id: "kursusPersonId",
        value: kursusPersonId,
      },
    ],
    form: [
      {
        component: "kursus",
        id: "nyKursusId",
        label: "Nye kursus",
        initialValue: "",
        isRequired: true,
        checkIfExam: true,
      },
      {
        component: "kode-select",
        id: "overnatning",
        label: "Overnatning",
        kodeListeType: "OvernatningstypeKode",
        initialValue: "MellemKursusdagene",
        placeholder: "Vælg overnatningstype",
        isRequired: true,
        conditionalHidden: ({ values }) => {
          return values.kursustype === 5;
        },
      },
      {
        component: "textinput",
        id: "afmeldingsGebyr",
        initialValue: "",
        label: "Afmeldingsgebyr",
        placeholder: "0",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      nyKursusId: Yup.string().required("Kursus skal være valgt"),
      overnatning: Yup.string().when("kursustype", {
        is: 5,
        then: (schema) => schema,
        otherwise: (schema) => schema.required("Overnatning skal være valgt"),
      }),
      afmeldingsGebyr: Yup.number().required("Afmeldingsgebyr skal være valgt"),
    }),
    post: (values) => {
      return {
        query: moveQuery,
        body: {
          ...values,
          overnatning:
            values.kursustype === 5 ? "IngenOvernatning" : values.overnatning,
        },
      };
    },
  };
};
